import { Activity } from "../../models/activity";
import {
  ActivityResponse,
  ActivityType,
  EventType,
} from "../../types/actionPlan";

export const activitiesResponse: ActivityResponse[] = [
  {
    id: 1,
    activity_type: ActivityType.LeadershipTraining,
    label: "Ok Boomer",
    start_date: "2024-01-01",
    end_date: "2024-02-28",
    events: [
      {
        id: 1,
        activity_id: 1,
        event_type: EventType.Touchpoint,
        date: "2024-01-01",
        label: "Ok Boomer Touchpoint 1",
        extra_properties: {
          touchpoint: {
            id: "TP.001",
            description: "Ok boomer touchpoint 1 description",
            order: 1,
          },
        },
      },
      {
        id: 2,
        activity_id: 1,
        event_type: EventType.Touchpoint,
        date: "2024-02-28",
        label: "Ok Boomer Touchpoint 2",
        extra_properties: {
          touchpoint: {
            id: "TP.002",
            description: "Ok boomer touchpoint 2 description",
            order: 2,
          },
        },
      },
    ],
    extra_properties: {
      training_module: {
        id: "TM.001",
        description: "Ok boomer module description",
      },
    },
  },
  {
    id: 2,
    activity_type: ActivityType.Training,
    label: "Allyship",
    start_date: "2024-01-09",
    end_date: "2024-01-09",
    events: [
      {
        id: 3,
        activity_id: 2,
        event_type: EventType.Touchpoint,
        date: "2024-01-01",
        label: "Allyship Touchpoint 1",
        extra_properties: {
          touchpoint: {
            id: "TP.003",
            description: "Allyship touchpoint 1 description",
            order: 1,
          },
        },
      },
    ],
    extra_properties: {
      training_module: {
        id: "TM.002",
        description: "Allyship module description",
      },
    },
  },
  {
    id: 3,
    activity_type: ActivityType.Survey,
    label: "Inclusion Survey",
    start_date: "2024-01-19",
    end_date: "2024-02-03",
    events: [
      {
        id: 4,
        activity_id: 3,
        event_type: EventType.SurveyLaunch,
        date: "2024-01-19",
        label: "Launch survey",
        extra_properties: {},
      },
      {
        id: 5,
        activity_id: 3,
        event_type: EventType.SurveyDueDate,
        date: "2024-02-03",
        label: "Survey due date",
        extra_properties: {},
      },
      {
        id: 6,
        activity_id: 3,
        event_type: EventType.SurveyReminder,
        date: "2024-01-28",
        label: "Reminder 1",
        extra_properties: {},
      },
    ],
    extra_properties: {
      dispatch: {
        id: "1",
      },
    },
  },
  {
    id: 4,
    activity_type: ActivityType.ScheduleSurvey,
    label: "Schedule Inclusion Survey",
    start_date: "2024-02-19",
    end_date: undefined,
    events: [
      {
        id: 7,
        activity_id: 4,
        event_type: EventType.ScheduleSurveyLaunch,
        date: "2024-02-19",
        label: "Launch survey",
        extra_properties: {},
      },
    ],
    extra_properties: {},
  },
];

export const noSurveyDueDateDataResponse: ActivityResponse[] = [
  activitiesResponse[3],
];

export const pastSurveyActivity = new Activity({
  id: 1,
  activity_type: ActivityType.Survey,
  label: "Inclusion Survey",
  start_date: "2023-12-19",
  end_date: "2024-01-03",
  events: [
    {
      id: 1,
      activity_id: 1,
      event_type: EventType.SurveyLaunch,
      date: "2023-12-19",
      label: "Launch survey",
      extra_properties: {},
    },
    {
      id: 2,
      activity_id: 1,
      event_type: EventType.SurveyDueDate,
      date: "2024-01-03",
      label: "Survey due date",
      extra_properties: {},
    },
  ],
  extra_properties: {
    dispatch: {
      id: "1",
    },
  },
});

export const activitiesData: Activity[] = activitiesResponse.map(
  (activity) => new Activity(activity)
);

/**
 * Mock data for preview subscription state.
 */
export const previewActivitiesResponse: ActivityResponse[] = [
  {
    id: 1,
    activity_type: ActivityType.LeadershipTraining,
    label: "Psychological Safety",
    start_date: "2024-12-01",
    end_date: "2025-01-01",
    events: [
      {
        id: 1,
        activity_id: 1,
        event_type: EventType.Touchpoint,
        date: "2024-12-01",
        label: "Touchpoint 1",
        extra_properties: {
          touchpoint: {
            description: "Understanding psychological safety",
            order: 1,
          },
        },
      },
      {
        id: 2,
        activity_id: 1,
        event_type: EventType.Touchpoint,
        date: "2025-01-01",
        label: "Touchpoint 2",
        extra_properties: {
          touchpoint: { description: "Creating safe spaces", order: 2 },
        },
      },
    ],
    extra_properties: {
      training_module: { id: "TM.001", description: "Psychological safety" },
    },
  },
  {
    id: 2,
    activity_type: ActivityType.Survey,
    label: "Inclusion Pulse",
    start_date: "2025-01-15",
    end_date: "2025-03-15",
    events: [
      {
        id: 3,
        activity_id: 2,
        event_type: EventType.SurveyLaunch,
        date: "2025-01-15",
        label: "Launch survey",
        extra_properties: {},
      },
      {
        id: 4,
        activity_id: 2,
        event_type: EventType.SurveyDueDate,
        date: "2025-03-15",
        label: "Survey due date",
        extra_properties: {},
      },
    ],
    extra_properties: {},
  },
  {
    id: 3,
    activity_type: ActivityType.Training,
    label: "Privilege Awareness",
    start_date: "2025-01-01",
    end_date: "2025-02-01",
    events: [
      {
        id: 5,
        activity_id: 3,
        event_type: EventType.Touchpoint,
        date: "2025-01-01",
        label: "Touchpoint 1",
        extra_properties: {
          touchpoint: { description: "Introduction to privilege", order: 1 },
        },
      },
      {
        id: 6,
        activity_id: 3,
        event_type: EventType.Touchpoint,
        date: "2025-02-01",
        label: "Touchpoint 2",
        extra_properties: {
          touchpoint: { description: "Taking action", order: 2 },
        },
      },
    ],
    extra_properties: {
      training_module: { id: "TM.002", description: "Understanding privilege" },
    },
  },
  {
    id: 4,
    activity_type: ActivityType.LeadershipTraining,
    label: "Inclusive Leadership",
    start_date: "2025-02-15",
    end_date: "2025-03-15",
    events: [
      {
        id: 7,
        activity_id: 4,
        event_type: EventType.Touchpoint,
        date: "2025-02-15",
        label: "Touchpoint 1",
        extra_properties: {
          touchpoint: { description: "Leadership foundations", order: 1 },
        },
      },
      {
        id: 8,
        activity_id: 4,
        event_type: EventType.Touchpoint,
        date: "2025-03-15",
        label: "Touchpoint 2",
        extra_properties: {
          touchpoint: { description: "Building inclusive teams", order: 2 },
        },
      },
    ],
    extra_properties: {
      training_module: { id: "TM.003", description: "Leading with inclusion" },
    },
  },
  {
    id: 5,
    activity_type: ActivityType.Training,
    label: "Allyship",
    start_date: "2025-04-01",
    end_date: "2025-05-01",
    events: [
      {
        id: 9,
        activity_id: 5,
        event_type: EventType.Touchpoint,
        date: "2025-04-01",
        label: "Touchpoint 1",
        extra_properties: {
          touchpoint: { description: "What is allyship", order: 1 },
        },
      },
      {
        id: 10,
        activity_id: 5,
        event_type: EventType.Touchpoint,
        date: "2025-05-01",
        label: "Touchpoint 2",
        extra_properties: {
          touchpoint: { description: "Being an effective ally", order: 2 },
        },
      },
    ],
    extra_properties: {
      training_module: { id: "TM.004", description: "Becoming an ally" },
    },
  },
  {
    id: 6,
    activity_type: ActivityType.ScheduleSurvey,
    label: "Inclusion Pulse",
    start_date: "2025-05-15",
    end_date: "2025-05-15",
    events: [
      {
        id: 11,
        activity_id: 6,
        event_type: EventType.ScheduleSurveyLaunch,
        date: "2025-05-15",
        label: "Launch survey",
        extra_properties: {},
      },
    ],
    extra_properties: {},
  },
  {
    id: 7,
    activity_type: ActivityType.LeadershipTraining,
    label: "Strategic DEI",
    start_date: "2025-05-01",
    end_date: "2025-06-01",
    events: [
      {
        id: 13,
        activity_id: 7,
        event_type: EventType.Touchpoint,
        date: "2025-07-01",
        label: "Touchpoint 1",
        extra_properties: {
          touchpoint: { description: "DEI strategy fundamentals", order: 1 },
        },
      },
      {
        id: 14,
        activity_id: 7,
        event_type: EventType.Touchpoint,
        date: "2025-08-01",
        label: "Touchpoint 2",
        extra_properties: {
          touchpoint: { description: "Implementing DEI initiatives", order: 2 },
        },
      },
    ],
    extra_properties: {
      training_module: {
        id: "TM.005",
        description: "Strategic DEI leadership",
      },
    },
  },
];

export const previewActivitiesData: Activity[] = previewActivitiesResponse.map(
  (activity) => new Activity(activity)
);

export const todoDataResponse = [
  {
    label: "Connect to HRIS",
    description:
      "In order to get the complete real-time DEI Health for your organisation, connect your HRIS.",
    isChecked: false,
    action: "integrations",
  },
  {
    label: "Promote Alda to employees",
    description:
      "In order to kick-off your DEI inititative, make sure your organisation is prepped and descriptionrmed. Don’t worry - Alda’s got you covered with some super simple and engaging promo material.",
    isChecked: false,
  },
  {
    label: "Setup survey",
    description:
      "The Inclusion Survey measures how inclusive your workplace truly is. In order to make the survey fit your organisation, please set up your preferences, recipients and survey timeline.",
    isChecked: false,
    action: "launch",
  },
  {
    label: "Get survey results",
    description:
      "Your survey results will be displayed in the Inclusion Index metric.",
    isChecked: false,
    action: "inclusionIndex",
  },
  {
    label: "Promote survey results",
    description:
      "Alda encourages DEI leaders to present the Inclusion Survey results and action plan to leadership and all employees.",
    isChecked: false,
  },
];
